import { render } from "./MobileMenuSticky.vue?vue&type=template&id=84d3fb66&scoped=true"
import script from "./MobileMenuSticky.vue?vue&type=script&lang=js"
export * from "./MobileMenuSticky.vue?vue&type=script&lang=js"

import "./MobileMenuSticky.vue?vue&type=style&index=0&id=84d3fb66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d3fb66"]])

export default __exports__